var _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDivider(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 96.2 18.3"
    },
    viewBox: "0 0 96.2 18.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M15.1 2.6c5.2-.2 9.8.8 14.2 2.8 1.9.8 3.9 1.4 6.1 1.1.9-.1 1.7-.3 2-1.3.1-.3 0-.7-.1-1-.3-.5-.6 0-.9.1-.1.1-.3.1-.5 0-.1 0-.1-.3-.1-.4.1-.7.5-1 1.2-1s1.1.3 1.3.9c.5 1.1.1 2.4-1 3-1.3.8-2.7 1.3-4.3.9-1.7-.5-3.3-.9-4.9-1.5C25.1 5 22 4.3 18.7 4c-.9-.1-1.7-.3-2.6-.3-3.8-.3-7.5.6-11 2.3-.5.2-1 .6-1.4 1-1.5 1.2-1.5 2.4-.4 3.9.2.3.5.6.7.8 1.2 1.1 2.3 1.4 3.3.8 1.2-.7 2-2.5 1.7-3.7-.2-.7-.7-1.1-1.4-1-.7.1-1 .5-.9 1.4 0 .2.2.4.2.6-.1.2-.3.5-.5.6-.1.1-.5-.1-.5-.2-.5-.7-.8-1.5-.3-2.4.6-1 1.4-1.4 2.5-1.3.9.1 1.6.6 1.8 1.6.4 1.4.2 2.7-.5 3.9-1.3 2.1-3.6 2.5-5.6 1.1-.2-.2-.4-.4-.7-.6C.5 10 .7 7.3 3.7 5.4 6.3 3.8 9.1 2.9 12 2.7c1.2-.1 2.3-.1 3.1-.1"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M-160-4066.4h414v5031h-414z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    style: {
      overflow: "visible",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-3.7-2.4h47.3v21.3H-3.7z",
    style: {
      clipPath: "url(#d)",
      fill: "#fff"
    }
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M80.9 2.6c-5.3-.1-9.9.9-14.4 2.8-2 .8-4 1.4-6.2 1.1-.9-.1-1.8-.3-2.1-1.3-.1-.3 0-.7.1-1 .3-.5.6 0 .9.1.1.1.3.1.5 0 .1 0 .1-.3.1-.4-.1-.7-.5-1-1.2-1s-1.1.3-1.4.9c-.5 1.1-.1 2.4 1 3 1.4.7 2.8 1.2 4.4.7 1.7-.5 3.4-.9 5-1.5 3.1-1.2 6.2-1.9 9.5-2.2.9-.1 1.7-.3 2.6-.3 4-.1 7.8.8 11.3 2.5.5.2 1 .6 1.4 1 1.5 1.2 1.5 2.4.4 3.9-.2.3-.5.6-.7.8-1.2 1.1-2.3 1.4-3.3.8-1.2-.7-2-2.5-1.7-3.7.2-.7.7-1.1 1.5-1 .7.1 1 .5.9 1.4 0 .2-.2.4-.2.6.1.2.3.5.5.6.1.1.5-.1.6-.2.4-.8.8-1.5.3-2.4-.6-1-1.4-1.4-2.6-1.3-.9.1-1.6.6-1.9 1.5-.4 1.4-.2 2.7.5 3.9 1.3 2.1 3.7 2.5 5.7 1.1.2-.2.4-.4.7-.6 2.7-2.5 2.5-5.2-.6-7.1C89.9 3.8 87 2.9 84 2.7c-1.1-.1-2.3-.1-3.1-.1"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#f)"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M-161.2-4066.4h419.4v5031h-419.4z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    style: {
      overflow: "visible",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52-2.4h47.9v21.3H52z",
    style: {
      clipPath: "url(#h)",
      fill: "#fff"
    }
  })), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M44.4 11.7c.2-.9.4-1.8.7-2.7.6-1.7 1.1-3.4 1.8-5.1.2-.6.9-.7 1.1-.2 1.8 3.3 3.6 6.7 2.9 10.7-.3 1.5-1.1 2.6-2.3 2.8-1.4.3-2.5-.4-3.3-1.5-.9-1.1-1-2.5-.9-4m3.4-6.5c-1.2 2.2-1.9 4.3-2.2 6.5-.1 1 .2 2.1.5 3.1.3.9 1 1.3 2 1.3 1.1 0 1.5-.9 1.7-1.7.2-.8.2-1.7.1-2.5-.2-2.3-1.1-4.4-2.1-6.7"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#j)"
    }
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M-160-4066.4h414v5031h-414z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    style: {
      overflow: "visible",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.4-1.5h16.7v23.9H39.4z",
    style: {
      clipPath: "url(#l)",
      fill: "#fff"
    }
  })), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M54.5 9.9c-.2-.1-.6-.2-1-.4-1.8-.9-2.7-2.5-3.6-4.1-.3-.5.1-1.1.7-.9 1.4.4 2.9.8 4.3 1.3.9.3 1.3 1.1 1.6 1.9.2 1-.9 2.3-2 2.2m-3-4.2c-.1.1-.2.3-.3.4.9.8 1.7 1.7 2.7 2.5.4.4 1 .3 1.3-.2.4-.6.1-1-.4-1.2-1.1-.6-2.2-1.1-3.3-1.5"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#n)"
    }
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M-160-4066.4h414v5031h-414z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    style: {
      overflow: "visible",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.8-.6h16.7v15.5H44.8z",
    style: {
      clipPath: "url(#p)",
      fill: "#fff"
    }
  })), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "q",
    d: "M38.9 7.8c0-.7.5-1.4 1.4-1.9 1.4-.9 3-1 4.5-1.4.4-.1.8.4.6.9-1 1.9-2.1 3.6-4.2 4.5-1.2.3-2.3-.4-2.3-2.1M44 6c-1.4.2-2.8.2-3.8 1.3-.2.2-.3.8-.2.9.3.3.7.4 1.1.4.2 0 .4-.2.5-.3.8-.7 1.6-1.5 2.4-2.3"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#r)"
    }
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M-160-4066.4h414v5031h-414z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    style: {
      overflow: "visible",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.9-.6h16.6v15.5H33.9z",
    style: {
      clipPath: "url(#t)",
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider);
export default __webpack_public_path__ + "static/media/divider.0c14129ea9553cacb5322bc3dd758d10.svg";
export { ForwardRef as ReactComponent };